// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router/index';
import messages from './shared/messages';
import Motopin from '@campbell-cloud/vue-motopin';
import CCi18n from '@campbell-cloud/vue-i18n';
import SearchBar from '@campbell-cloud/vue-search-bar-2';
import Toastr from '@campbell-cloud/mini-toastr';
import CCVueComponents from '@campbell-cloud/cc-vue-components';
import VueMatomo from 'vue-matomo';
import Vuex from 'vuex';
import { store, init as storeInit } from '@/shared/store.js';
import ECharts from 'vue-echarts';
import 'echarts';

// uncomment this to auto-logout when logged out and debugging on localhost
import appConfig from '../app.config';
import vueConfig from '../vue.config';
import { domain, protocol } from './api';

import security from '@campbell-cloud/vue-cc-security';
Vue.use(security);
// todo
// cssVars()

Vue.use(Vuex);
storeInit();

Vue.use(Toastr, { timeout: 8000, showClose: true });

Vue.use(Motopin, {
  key: appConfig.application_name
});

Vue.use(BootstrapVue);
Vue.use(CCi18n, {
  messages,
  namespace: appConfig.application_name // ex: "wsms", "translation_admin", "goes", "traffic"
});
Vue.use(SearchBar);
Vue.use(Toastr);
Vue.use(CCVueComponents);
Vue.component('v-chart', ECharts);

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: `${protocol}//analytics.${domain}`,
  siteId: 1,

  // Enables automatically registering pageviews on the router
  router: false, // kk - automatic router tracking doesn't use the path prefix, so there's no differentiation between the different apps

  // Whether to track the initial page view
  // Default: true
  trackInitialView: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: `*.${domain}`,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: `*.${domain}`,
});


router.beforeEach((to, from, next) => {
  Vue.nextTick(() => {
    window._paq.push(['setCustomUrl', `${vueConfig.publicPath}${to.path.substring(1)}`]);
    window._paq.push(['setReferrerUrl', `${vueConfig.publicPath}${from.path.substring(1)}`]);
    window._paq.push(['setDocumentTitle', `${appConfig.application_title} - ${to.name}`]);
    window._paq.push(['trackPageView']);
    next();
  });
});

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // check that click was outside the el and children
      const closeButton = el.querySelector('.cc-aside-close');
      const isPopover = Array.from(event.target.classList).includes('popover-body');
      const isCloseButton = closeButton ? closeButton.contains(event.target) : false;
      const isToastr = (document.querySelector('#mini-toastr.mini-toastr')).contains(event.target);
      const isInside = el.contains(event.target);
      const isMultiselect = Array.from(event.target.classList).some(s => s.includes('multiselect'));

      if (binding.expression && !isInside && (!isPopover && !isCloseButton && !isToastr && !isMultiselect)) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('mousedown', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('mousedown', el.clickOutsideEvent);
  },
  stopProp(event) { event.stopPropagation(); }
});


security.init({ protocol: protocol, baseUrl: domain, client: `${appConfig.application_name}`, realm: 'campbell-cloud' }).then(() => {
  router.beforeEach(security.routeGuard.bind(router));

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: {
      App
    },
    template: '<App/>',
    store,
    ...CCi18n.vueInitOptions
  });
})
  .catch(err => {
    console.error(err);
  });